// import { defaultAuthState } from './module-auth-state';

export default {
  resetState(state) {
    console.log(state);
  },
  /**
   * Cập nhật các thông tin liên quan tới accesstoken của mtax
   */
  updateAccessToken: function (state, payload) {
    state.tokenType = payload.tokenType;
    state.jPAccessToken = payload.accessToken;
    state.jPExpire = payload.expiresIn;
    state.jPrefreshToken = payload.refreshToken;
    state.startDate = new Date();
    // state.userInfo = payload.User;
  },
  /**
   * Cập nhật các thông tin liên quan tới accesstoken của misaid
   */
  updateMisaToken: function (state, payload) {
    state.misaAccessToken = payload.misaAccessToken;
    state.misaExpire = payload.misaExpire;
    state.misaRefreshToken = payload.misaRefreshToken;
    state.LinkSignalR = payload.LinkSignalR;
    state.RunSignalR = payload.RunSignalR;
  },
  updateStatusActive: function (state, payload) {
    state.EmailActive = payload.EmailActive;
    state.PhoneActive = payload.PhoneActive;
  },

  updateIsLaterState: function (state, value) {
    state.isLater = value;
  },
  updateTimeout: function (state, value) {
    state.timeOut = value;
  },
};
